import { Stack } from '@mui/material'
import { useWidgetStatistics } from 'components/farm-dashboard/hooks/useWidgetStatistics'
import { useAppSelector } from 'store/hooks'
import { COLORS } from 'styles/colors'
import DonutChart from 'ui/charts/donut-chart/DonutChart'
import { BaseWidget } from '../baseWidget'
import { LargeHerdStructureWidgetTable } from './Table/LargeHerdStructureWidgetTable'

export const LargeHerdStructureWidget = () => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const { statistics, loading, error } = useWidgetStatistics()

	if (!permissions?.license_fatness || error) return null
	const herd = statistics?.herd
	const categories = [herd?.milky ?? 0, herd?.dry ?? 0]
	const colors = [COLORS.main, COLORS.mainOpacity]
	return (
		<BaseWidget
			isLoading={loading}
			title='Структура стада'
			path='/cattles'
			pathLable='Перейти в поголовье'
		>
			<Stack direction='row' justifyContent='center'>
				<DonutChart colors={colors} categories={categories} height='126px' />
			</Stack>
			<LargeHerdStructureWidgetTable herd={herd} />
		</BaseWidget>
	)
}
